import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { GET_ANNOUNCEMENT_DETAILS_QUERY_KEY } from '../../constants/queryKeys';
import { GET_ANNOUNCEMENT_DETAILS_URL } from '../../constants/apiUrls';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface RecipientSelection {
  candidateTypes?: string[] | null;
  examLevels?: string[] | null;
  examCentres?: string[] | null;
  examGroups?: string[] | null;
  appointments?: string[] | null;
  everyone?: boolean;
  candidateRecipient?: boolean;
  individualRecipient?: boolean;
}

export interface FileInfoDetails {
  fileUuid: string;
  fileName: string;
  fileSizeInBytes: number;
  submitted: boolean;
}

interface AnnouncementDetailsResponse {
  announcementType: string;
  title: string;
  description: string;
  fileInfo: FileInfoDetails[];
  recipientSelection: RecipientSelection;
  startDate: string;
  endDate: string;
  priority: boolean;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (res: AnnouncementDetailsResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
  enabled: boolean;
}

export const useGetAnnouncementDetails = ({ onSuccess, onError, uuid, enabled }: Input) => {
  const getAnnouncementDetails = async () => {
    const res = await axiosClient.get<AnnouncementDetailsResponse>(
      GET_ANNOUNCEMENT_DETAILS_URL(uuid)
    );
    return res.data;
  };

  return useCustomQuery(GET_ANNOUNCEMENT_DETAILS_QUERY_KEY.concat(uuid), getAnnouncementDetails, {
    onSuccess,
    onError,
    enabled,
  });
};
